import { useEffect, useState } from 'react';
import { getServerApiCompanyParams } from '../api/client/companyDetailsApi';

const useGetCompanyParams = companyId => {
  const [companyParams, setCompanyParams] = useState(null);

  useEffect(() => {
    if (companyId) {
      getServerApiCompanyParams(companyId)
        .then(data => setCompanyParams(data))
        .catch(error => console.log(error));
    }
  }, [companyId]);

  return { companyParams };
};

export default useGetCompanyParams;
